<template>
    <div id="warning-method" class="grid">
        <div class="grid-title">
            <h4>{{ $t("WARNING_METHOD") }}</h4>
            <v-btn color="primary" @click="save" class="pl-10 pr-10">{{ $t("SAVE") }}</v-btn>
        </div>
        <div class="grid-body p-3 pb-0 border-top-unset">
            <v-form ref="form" lazy-validation v-on:submit.prevent>
                <b-row>
                    <b-col md="6" class="pt-0">
                        <div>
                            <label class="label-title">{{ $t("ALERT_RECEIVING_METHOD") }}</label> <br>
                            <div class="mt-3">
                                <label class="label-input">
                                {{ $t("SELECT_WARNING_METHOD") }}
                                </label>
                                <v-autocomplete
                                    :items="method"
                                    v-model="selectedMethod"
                                    item-text="name"
                                    item-value="value"
                                    outlined dense
                                ></v-autocomplete>
                            </div>
                        </div>
                    </b-col>
                    <b-col md="6" class="pt-0">
                        <div>
                            <label for=""></label>
                            <div class="mt-3">
                                <label class="label-input">
                                {{ $t("WARNING_EMAIL") }} *
                                </label>
                                <v-text-field v-model="data.warningEmail" outlined dense :rules="ruleEmailWarning" validate-on-blur></v-text-field>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                
                <div>
                    <label class="label-title">{{ $t("WARNING_QTY_ROOM") }}</label> <br>
                    <div class="row-process mb-0">
                        <b-row>
                            <b-col md="12" class="pb-0 pt-0" :class="!checkWarning ? 'mb-3' : 'mb-0'">
                                <v-checkbox :label="$t('SETTING_WARNING_ROOM')" v-model="checkWarning" color="indigo darken-3" ></v-checkbox>
                            </b-col>
                            <b-col v-if="checkWarning" md="12" class="pt-0 pl-6">
                                <v-radio-group v-model="data.warningLevel" class="mt-1">
                                    <div class="any-room">
                                        <v-radio :label="$t('SEND_WARNING_ANY_ROOM')" :checked="data.warningLevel === 1" :value="1" class="mb-0"></v-radio>
                                        <input :disabled="data.warningLevel !== 1" :class="data.warningLevel !== 1 ? 'disabled' : ''" class="custom-input-field custom-input w-100px ml-3" v-model="valueMinAllHotel.thresholdMax" @input="formatInputAll"/>
                                    </div>
                                    <v-radio :label="$t('SEND_WARNING_ROOM')" :value="2" class="mt-3"></v-radio>
                                </v-radio-group>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-if="checkWarning && isShow">
                    <b-container fluid>
                        <b-row class="g-4 custom-row">
                            <b-col v-for="(room, index) in listWarningRoom" :key="room.keyId" md="6" class="custom-col bg-warning-method">
                                <div class="d-flex">
                                    <div class="w-50">
                                        <label class="label-input mb-1"> {{ $t("ROOM_TYPE") }} </label>
                                        <v-autocomplete
                                            ref="listRoom"
                                            class="bg-light"
                                            :items="filteredRoomList(room.keyId, index)"
                                            v-model="room.keyId"
                                            item-text="name"
                                            item-value="id"
                                            outlined dense
                                            :rules="ruleRequiedRoomTye"
                                        >
                                        <template v-slot:selection="{ item }">
                                            <span>{{ item.name }}</span>
                                        </template>
                                        <template slot="no-data">
                                            <div class="no-data">{{ $t("NO_DATA") }}</div>
                                        </template>
                                        </v-autocomplete>
                                    </div>
                                    <div class="ml-3 w-50">
                                        <label class="label-input mb-1"> {{ $t("QTY_ROOM_LESS_THAN") }} </label>
                                        <v-text-field v-model="room.thresholdMax" @input="formatInputRoom(room)" class="bg-light" outlined dense></v-text-field>
                                    </div>
                                    <v-icon color="error" class="btn-delete mt-8 ml-3" @click="removeRoom(index)">
                                        delete
                                    </v-icon>
                                </div>
                            </b-col>
                            <b-col>
                                <v-btn small color="primary" class="btn-add mt-1" @click="addRoom" :disabled="this.listWarningRoom.length === this.listRoomSetting.length" depressed>
                                    <v-icon> add </v-icon>
                                    {{ $t("_ACTIVITY.HOTEL_ROOM_CREATED") }}
                                </v-btn>
                            </b-col>
                        </b-row>
                    </b-container>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
import { service } from "@/_services/HotelSetting/warning.service.js";
import { _alert } from "@/_helpers/function.js";
export default {
  data() {
    return {
        selectedMethod: '2',
        method: [
            {
                value: '2',
                name: 'Email'
            }
        ],
        data: {},
        checkWarning: null,
        hotelId: null,
        valueMinAllHotel: {},
        isShow: false,
        listWarningRoom: {},
        listRoomSetting: [],
        isDisabled: false,
        sysLang: this.$i18n.locale
    };
  },
  created() {
    this.hotelId = JSON.parse(localStorage.getItem("currentUser")).hotel.id;
    this.initial();
  },
  watch: {
    'data.warningLevel'(value) {
        if(+value === 2) {
            this.isShow = true;
        } else {
            this.isShow = false;
        }
    },
    checkWarning(value) {
        if (this.data.warningLevel === 0) {
            this.data.warningLevel = value ? 1 : 0;
        }
    },
  },
  methods: {
    async initial() {
        await service.get().then(res => {
            if (res.responseCode === 0) {
                this.data = res.data;
                this.data.warningLevel === 0 ? this.checkWarning = false : this.checkWarning = true;
                this.valueMinAllHotel = this.data.details.find(x => x.keyType === 1);
                if (!this.valueMinAllHotel) {
                    this.valueMinAllHotel = {
                        keyId: this.hotelId,
                        keyType: 1,
                        thresholdMax: 0,
                        thresholdMin: null
                    }
                }
                this.listWarningRoom = this.data.details.filter(x => x.keyType !== 1);
                
            }
        })
        await service.getAllRooms().then(res => {
            this.listRoomSetting = res.data
            .filter(x => x.parentId == null)
            .map(x => {
                return {
                    id: x.roomId,
                    name: x.i18ns.find(y => y.lang == this.defaultI18n).name
                };
            });
        })

        // this.listWarningRoom = this.listWarningRoom.filter(room =>
        //     this.listRoomSetting.some(setting => setting.id === room.keyId)
        // );

    },
    formatInputAll() {
        let value = event.target.value;
        this.$nextTick(() => {
            value = value.replace(/[^0-9-]/g, "");
            if (value === "0-") {
                value = value.replace(/-/g, "").replace("0", "");
                value = "-" + value;
            } else if (value.includes("-")) {
                value = value.replace(/-/g, "");
                value = "-" + value;
            }

            if (value === "" || value === "-") {
                this.valueMinAllHotel.thresholdMax = value;
            } else {
                value = value.replace(/^(-?)0+(\d)/, "$1$2");
                this.valueMinAllHotel.thresholdMax = value;
            }
            
            if (this.valueMinAllHotel.thresholdMax === "") {
                this.valueMinAllHotel.thresholdMax = "0";
            }
            event.target.value = this.valueMinAllHotel.thresholdMax;
        });
    },
    formatInputRoom(room) {
        let newValue = event.target.value.replace(/\D/g, "").trim();
        if (newValue.length > 1) {
            newValue = newValue.replace(/^0+/, "");
        }
        this.$nextTick(() => {
            room.thresholdMax = newValue || "0";
            event.target.value = room.thresholdMax;
        });
    },
    addRoom() {
        if (this.listWarningRoom.length < this.listRoomSetting.length) {
            this.listWarningRoom.push({
                keyId: null,
                keyType: 2,
                thresholdMax: 0,
                thresholdMin: null
            })
        }
    },
    filteredRoomList(selectedId, index) {
        const selectedIds = this.listWarningRoom
            .filter((_, i) => i !== index)
            .map(room => room.keyId);

        const filtered = this.listRoomSetting.filter(room => !selectedIds.includes(room.id));

        if (selectedId && !filtered.some(room => room.id === selectedId)) {
            const selectedRoom = this.listRoomSetting.find(room => room.id === selectedId);
            if (selectedRoom) {
                return [...filtered, selectedRoom];
            }
        }
        return filtered;
    },
    removeRoom(index) {
        const removedRoom = this.listWarningRoom[index];

      if (removedRoom.keyId) {
        this.listRoomSetting.push({
          id: removedRoom.keyId,
          name: this.getRoomNameById(removedRoom.keyId)
        });
      }
      this.listWarningRoom.splice(index, 1);
    },
    getRoomNameById(id) {
      const room = this.listRoomSetting.find(room => room.id === id);
      return room ? room.name : "Undefined";
    },
    save() {
        let form_validate = this.$refs.form.validate();
        this.$refs.listRoom && this.$refs.listRoom.forEach(room => {
            if (!room.value) {
            this.$nextTick(() => {
                const el = document.querySelector(".v-messages.error--text");
                if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
            });
            return false;
            }
        });
        
        if (this.data.warningLevel === 2 && this.listWarningRoom.length === 0) {
            this.$store.commit("alert/display", {
              message: this.$t('SETTING_AT_LEAST_1_ROOM'),
              error: true,
              success: false,
            });
            return false;
        }
        if (!form_validate) {
          this.$nextTick(() => {
              const el = document.querySelector(".v-messages.error--text");
              if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          });
        return false;
        }
      
        const body = {
            warningLevel: !this.checkWarning ? 0 : this.data.warningLevel,
            warningType: 1,
            bitMethod: 2,
            warningEmail: this.data.warningEmail.replace(/\s/g, "").replace(",", ", ").trim(),
            details: [this.valueMinAllHotel, ...Object.values(this.listWarningRoom)]
        }

        service.update(body).then(res => {
            _alert(res, this.$t(res.data));
        });
    }
  }
};
</script>

<style scoped>
.any-room {
    display: flex;
}
.any-room .w-100px {
    max-width: 80px !important;
}
.any-room .v-radio {
    line-height: 10px;
}
.bg-warning-method {
    background: linear-gradient(0deg, rgba(0, 62, 148, 0.1), rgba(0, 62, 148, 0.1)), #ffffff;
    border-radius: 5px;
}
.custom-row {
    display: flex;
    gap: 1%;
    padding-bottom: 15px;
}
.custom-col {
  max-width: 49% !important;
  margin-bottom: 12px !important;
}
.custom-col:nth-child(odd) {
  margin-right: 0.5%;
}
.custom-col:nth-child(even) {
  margin-left: 0.5%;
}
.btn-add.v-btn.v-btn--disabled {
  background-color: #ccc !important;
  color: #666 !important;
  border-color: #bbb !important;
}
.btn-delete {
    height: fit-content;
}
.custom-input-field {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  width: 100%;
  border: 1px solid #aaaaaa;
  border-radius: 3px;
  padding: 0 12px;
}
.disabled {
  background-color: #f0f0f0;
  color: #999;
  border: 1px solid #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>